import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const PermCtx = createContext({ permissions: {}, can: () => false, loading: true, refresh: () => {} });

/**
 * Pulls the current user's effective permission matrix from /permissions/me.
 * All components use `can(key)` to gate UI (Reprint button, Discount input, etc.).
 */
export function PermissionsProvider({ children }) {
  const { user } = useAuth();
  const [permissions, setPermissions] = useState({});
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!user || user === false) {
      setPermissions({});
      setLoading(false);
      return;
    }
    setLoading(true);
    try {
      const r = await api.get("/permissions/me");
      setPermissions(r.data?.permissions || {});
    } catch {
      setPermissions({});
    } finally { setLoading(false); }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const can = (key) => Boolean(permissions[key]);

  return (
    <PermCtx.Provider value={{ permissions, can, loading, refresh }}>
      {children}
    </PermCtx.Provider>
  );
}

export const usePermissions = () => useContext(PermCtx);
